import {useEffect, useMemo} from "react";
import {useImmer} from "use-immer";


const initialData = {};
const PERCENT_SIGN_REG_EXP = /^([^%]*%)[^%]*$/;



function useMqttSubscription(mqttClient, machines, mqttTopic, dataTransformOperation) {

    const [mqttData, updateMqttData] = useImmer(initialData);

    const validMachineNames = useMemo(() => {
        const namesArray = Array.isArray(machines) ? machines : [machines];
        return namesArray.map(m => m.name).filter(name => Boolean(name));
    }, [machines]);


    useEffect(() => {
        console.log("useMqttSubscription useEffect");

        function subscribeTopic(topic, callback) {
            if (!topic || typeof topic !== 'string') {
                throw new Error('Subscription key must be a non-empty string');
            }
            console.log("useMqttSubscription subscribe", topic);
            mqttClient.subscribeTopic(topic, callback);
        }

        function getReplacedContent(originalString, modifiedString) {
            const index = originalString.indexOf("%");
            const length = modifiedString.length - originalString.length;
            return modifiedString.substring(index, index + length + 1);
        }
        
        function messageCallback(topic, message) {
            if (dataTransformOperation && typeof dataTransformOperation === 'function') {
                message = dataTransformOperation(message);
            }

            const machineName = getReplacedContent(mqttTopic, topic);

            updateMqttData((draft) => {
                if (message && message !== "" && message.size !== 0) {
                    draft[machineName] = message;
                }
            });
        }


        function assertStringContainsPercentSignOnce(inputString) {
            return PERCENT_SIGN_REG_EXP.test(inputString);
        }


        if (mqttClient) {
            console.log("useMqttSubscription subscribing", mqttTopic);
            if (!assertStringContainsPercentSignOnce(mqttTopic)) {
                console.error("mqtt topic must contain exactly one '%' (" + mqttTopic + ")");
                return;
            }

            for (const machineName of validMachineNames) {
                const fullTopic = mqttTopic.replace("%", machineName);
                subscribeTopic(fullTopic, messageCallback);
            }
        }

        return () => {
            console.log("useMqttSubscription unmount");
        }

    }, [dataTransformOperation, mqttClient, mqttTopic, updateMqttData, validMachineNames]);

    return mqttData;
}



export default useMqttSubscription;
